export default "__VITE_ASSET__DOIFwd63__"